<template>
  <div class="card my-2" style="border: none;">
    <div class="row">
      <div class="col-md-3 ps-0">
        <ul class="nav nav-profile nav-tabs flex-column" role="tablist">
          <li class="nav-item">
            <a
              href="?tab=general"
              data-bs-target="#general"
              data-bs-toggle="tab"
              role="tab"
              class="nav-link text-decoration-none"
              :class="{ active: currentTab === 'general' }"
              @click.prevent="setActiveTab('general')"
            >
              {{ $t('settings.general') }}
            </a>
          </li>
          <li class="nav-item">
            <a
              href="?tab=security"
              data-bs-target="#security"
              data-bs-toggle="tab"
              role="tab"
              class="nav-link text-decoration-none"
              :class="{ active: currentTab === 'security' }"
              @click.prevent="setActiveTab('security')"
            >
              {{ $t('network.user.securityTab') }}
            </a>
          </li>
          <li class="nav-item">
            <a
              href="?tab=notifications"
              data-bs-target="#notifications"
              data-bs-toggle="tab"
              role="tab"
              class="nav-link text-decoration-none"
              :class="{ active: currentTab === 'notifications' }"
              @click.prevent="setActiveTab('notifications')"
            >
              {{ $t('settings.notifications') }}
            </a>
          </li>
          <li class="nav-item">
            <a
              href="?tab=workinfo"
              data-bs-target="#workinfo"
              data-bs-toggle="tab"
              role="tab"
              class="nav-link text-decoration-none"
              :class="{ active: currentTab === 'workinfo' }"
              @click.prevent="setActiveTab('workinfo')"
            >
              {{ $t('settings.work-info') }}
            </a>
          </li>
          <li class="nav-item">
            <a
              href="?tab=researchcreds"
              data-bs-target="#researchcreds"
              data-bs-toggle="tab"
              role="tab"
              class="nav-link text-decoration-none"
              :class="{ active: currentTab === 'researchcreds' }"
              @click.prevent="setActiveTab('researchcreds')"
            >
              {{ $t('settings.research-creds') }}
            </a>
          </li>
          <!--<li class="nav-item">
            <a href="" data-bs-target="#attendance" data-bs-toggle="tab" role="tab"
              class="nav-link text-decoration-none">
              Attendance certificates
            </a>
          </li>-->
        </ul>
      </div>
      <div class="col-md-9">
        <div id="myTabContent" class="tab-content">
          <div id="general" role="tabpanel" aria-labelledby="general-tab" class="tab-pane fade" :class="{ 'show active': currentTab === 'general' }">
            <h4>{{ $t('settings.general') }}</h4>
            <p>{{ $t('add-or-update-basic-information-related-to-you-and-manage-other-account-settings') }}</p>
            <div class="col-md-12 col-lg-12 col-sm-12">
              <UserForm :form="form" :fields="userFormFields" :urlToken="urlToken" :profile="true" @user-form-submit="data => submitUserForm(data)" />
              <div class="row">
                <div class="col-md-12">
                  <div v-if="submitStatus == 'PENDING'" class="alert alert-info mt-3 mb-n3">
                    <i class="fas fa-spin fa-gear"></i>
                    {{ $t('network.user.submittingForUpdate') }}
                  </div>
                  <div v-if="submitStatus == 'ERROR'" class="alert alert-warning text-black fw-semibold mt-3 mb-n3">
                    {{ $t('network.user.regError') }}
                    <pre>{{ errors }}</pre>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="security" role="tabpanel" aria-labelledby="security-tab" class="tab-pane fade" :class="{ 'show active': currentTab === 'security' }">
            <h4>{{ $t('network.user.securityTab') }}</h4>
            <p>{{ $t('here-you-will-receive-information-and-updates-on-security-changes-made-to-your-account-you-will-also-be-notified-of-important-actions-to-be-undertaken-like-email-verification-or-addition-etc') }}</p>
            <div v-if="user.email_verified_at">
              <span>{{ $t('verified-email') }} {{ user.email }}</span><br />
              <span v-if="user.password_changed_at">{{ $t('password-last-changed') }} {{ user.password_changed_at }}</span>
            </div>
            <div v-else>
              <span class="text-danger">{{ $t('your-email-is-not-verified') }}</span>
            </div>
            <hr style="background: repeating-linear-gradient(239deg, transparent, transparent 10px, black 10px, black 20px);margin: 20px 0px;">
            <p>{{ $t('to-reset-your-password-or-link-additional-emails-please-visit-authentication') }}</p>
            <a :href="authURL" target="_blank">
              <button id="visit_authentication" data-test="visit_authentication" style="border: 2px solid; padding: 0.65rem 1.8rem !important;" class="btn btn-primary">{{ $t('visit-authentication') }}</button>
            </a>
          </div>
          <div id="notifications" role="tabpanel" aria-labelledby="notifications-tab" class="tab-pane fade" :class="{ 'show active': currentTab === 'notifications' }">
            <h4>{{ $t('settings.notifications') }}</h4>
            <p>{{ $t('select-your-email-and-broadcast-permissions-for-networks') }}</p>
            <hr style="background: repeating-linear-gradient(239deg, transparent, transparent 10px, black 10px, black 20px);margin: 20px 0px;">
            <Notifications />
          </div>
          <div id="workinfo" role="tabpanel" aria-labelledby="workinfo-tab" class="tab-pane fade" :class="{ 'show active': currentTab === 'workinfo' }">
            <h4>{{ $t('settings.work-info') }}</h4>
            <span>{{ $t('add-or-update-information-related-to-your-workplace') }}</span>
            <Workinfo />
          </div>
          <div id="researchcreds" role="tabpanel" aria-labelledby="researchcreds-tab" class="tab-pane fade" :class="{ 'show active': currentTab === 'researchcreds' }">
            <h4>{{ $t('settings.research-creds') }}</h4>
            <p>{{ $t('add-or-update-information-related-to-your-research-credentials-and-certifications') }}</p>
            <ResearchCreds />
          </div>
          <!--<div id="attendance" role="tabpanel" aria-labelledby="attendance-tab" class="tab-pane fade">
              <h4>Attendance certificates</h4>
              <p>Here you can generate and access attendance certificates for networks meetings.</p>
              <div v-if="loaded">
                <hr style="background: repeating-linear-gradient(239deg, transparent, transparent 10px, black 10px, black 20px); margin: 20px 0px;">
                <div v-if="uniqueNetworks.length > 0">
                  Choose the network for which you would like to generate a certificate
                  <v-select
                    id="networkSelect"
                    v-model="selectedNetwork"
                    data-test="networkSelect"
                    :options="uniqueNetworks"
                    :placeholder="$t('network.networkForm.selectNetwork')"
                    class="mt-2"
                  ></v-select>
                  <hr style="background: repeating-linear-gradient(239deg, transparent, transparent 10px, black 10px, black 20px); margin: 20px 0px;">
                </div>
                <ag-grid-vue
                  v-if="selectedNetwork"
                  style="width: 100%; height: 357px; font-family: 'Nunito', sans-serif;"
                  class="ag-theme-alpine text-center"
                  :gridOptions="gridOptions"
                  :frameworkComponents="frameworkComponents"
                  :columnDefs="columnDefs"
                  :pagination="true"
                  paginationPageSize="5"
                  :rowData="sortedArray(filteredCertificates)"
                  @selection-changed="onSelectionChanged"
                  @grid-ready="onGridReady"
                ></ag-grid-vue>
                <div v-else>
                  <span v-if="Object.keys(filteredCertificates).length === 0">
                    Currently, no attendance certificates are available.<br>
                    Attend a meeting to request certificates or
                    <span class="text-primary pointer" @click="contactNow">reach out to our support team</span> for assistance.
                  </span>
                  <span v-else>
                    {{ $t('please-select-a-network') }}<br>
                    If you don't see the network you are looking for,
                    <span class="text-primary pointer" @click="contactNow">reach out to our support team</span> for assistance.
                  </span>
                </div>
              </div>
              <div v-else class="row text-center mt-6">
                <i class="fas fa-5x fa-spinner"></i>
              </div>
            </div>-->
        </div>
      </div>
    </div>
    <b-modal v-model="showReviewModal" hide-header hide-footer size="lg">
      <div class="container px-0">
        <span>
          {{ $t('thank-you-for-participating-in-the-meeting-please-select-the-boxes-that-best-describe-your-experience-your-feedback-is-optional-but-highly-valuable') }}
        </span>
        <div class="my-3 d-flex align-items-center justify-content-center">
          <button v-for="(button, index) in buttons.slice(0, 3)" :key="button.id" class="btn btn-review mx-3" :class="{ 'btn-selected': button.selected }"
          @click="toggleButton(button)">{{ button.label }}</button>
        </div>
        <div class="my-3 d-flex align-items-center justify-content-center">
          <button v-for="(button, index) in buttons.slice(3)" :key="button.id" class="btn btn-review mx-3" :class="{ 'btn-selected': button.selected }"
          @click="toggleButton(button)">{{ button.label }}</button>
        </div>
        <textarea v-if="isOtherSelected" id="meeting_review" v-model="review" data-test="meeting_review" rows="5" :placeholder="$t('keep-your-feedback-brief-and-under-300-characters')"
        maxlength="300" class="form-control mb-3"></textarea>
        <div class="text-center">
          <button class="btn btn-block btn-sm btn-outline-primary" style="padding: 0.425rem 1.7rem !important; border: 2px solid;" @click="requestCertificate()">
            {{ $t('request-certificate') }}
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import UserForm from '@/components/forms/profile/UserForm.vue';
import Workinfo from '@/views/user/Workinfo.vue';
import ResearchCreds from '@/views/user/ResearchCreds.vue';
import Notifications from '@/views/user/Notifications.vue';
import '@/lib/vue-form-generator';
import '@/lib/ag-grid';
import moment from 'moment';
import 'vue-select/dist/vue-select.css';
import orderBy from 'lodash/orderBy';
import BtnCertificateRequest from './BtnCertificateRequest.js';

export default {
  components: {
    UserForm,
    Workinfo,
    ResearchCreds,
    Notifications,
  },
  props: {
    activeTab: {
      type: String,
      default: 'general',
    },
  },
  data() {
    return {
      currentTab: this.activeTab,
      loaded: false,
      busy: false,
      user: this.$store.getters['user'],
      authURL: process.env.VUE_APP_OAUTH_SERVER_URI,
      userFormFields: {
        name_prefix: true,
        first_name: true,
        last_name: true,
        name_suffix: true,
        phone_number: true,
        address: true,
        city: true,
        country: true,
        is_hcp: true,
        is_industry: true,
        is_other: true,
      },
      urlToken: '',
      networkForInvitation: null,
      submitStatus: '', // ERROR PENDING or OK
      errors: {},
      show: false,
      params: {
        token: '123456798',
        name: 'avatar',
      },
      headers: {
        smail: '*_~',
      },
      imgDataUrl: '',
      formLeaveWithoutSave : false,
      attendance_certificates: [],
      uniqueNetworks: [],
      selectedNetwork: null,
      selectedAttendanceID: null,
      showReviewModal: false,
      buttons: [
        { id: 1, label: this.$t('engaging-session'), selected: false },
        { id: 2, label: this.$t('responsive-host'), selected: false },
        { id: 3, label: this.$t('started-on-time'), selected: false },
        { id: 4, label: this.$t('interesting-case-presentation'), selected: false },
        { id: 5, label: this.$t('good-discussion'), selected: false },
        { id: 6, label: this.$t('other'), selected: false },
      ],
      review: '',
      gridOptions: null,
      frameworkComponents: null,
      columnDefs: null,
      rowData: null,
      selectedRows: [],
      selectedUser: [],
    };
  },
  computed: {
    form: function () {
      return {
        id: this.user.user_id,
        user_name: this.user.user_name,
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        name_prefix: this.user.name_prefix,
        name_suffix: this.user.name_suffix,
        email: this.user.email,
        phone_number: this.user.phone_number,
        address: this.user.address,
        city: this.user.city,
        country: this.user.country,
        profile_image_url: this.user.profile_image_url,
        is_hcp: this.user.is_hcp,
        is_industry: this.user.is_industry,
        is_other: this.user.is_other,
      };
    },
    filteredCertificates() {
      if (!this.selectedNetwork) {
        return this.attendance_certificates;
      }
      return this.attendance_certificates.filter(item => item.network === this.selectedNetwork);
    },
    isOtherSelected() {
      return this.buttons[this.buttons.length - 1].selected;
    },
  },
  watch: {
    attendance_certificates() {
      this.updateUniqueNetworks();
    },
    filteredRequests: {
      handler(newV) {
        this.filteredCertificateRequests = newV;
      },
    },
    review(newV) {
      this.review = newV;
    },
    activeTab(newTab) {
      this.currentTab = newTab;
    },
  },
  beforeMount() {
    this.gridOptions = {
      defaultColDef: {
        width: 150,
        resizable: true,
        floatingFilter: true,
      },
      components: {
      },
    };
    this.onGridReady = () => {
      let filters = document.querySelectorAll('.ag-input-field-input');
      filters.forEach(filter => {
        filter.placeholder = this.$t('network.search');
      });
    };
    this.frameworkComponents = {
      btnCellRenderer: BtnCertificateRequest,
    };
    this.columnDefs = [
    {
      sortable: true,
      filter: true,
      filterParams: {
        filterOptions: ['contains'],
        suppressAndOrCondition: true,
        buttons: ['clear'],
      },
      headerName: 'Event',
      headerComponentParams: {
        template:
          '<div class="ag-cell-label-container" role="presentation">' +
          '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
          '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
          '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
          '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
          '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
          '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
          '    <i class="fas fa-users-class"></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
          '    <span ref="eFilter" class="ag-header-icon ag-filter-icon" style="display: flex; text-align: start !important;"></span>' +
          '  </div>' +
          '</div>',
      },
      field: 'title',
      flex: 1,
    },
    {
      sortable: true,
      headerName: 'Date',
      headerComponentParams: {
        template:
        '<div class="ag-cell-label-container" role="presentation">' +
          '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
          '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
          '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
          '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
          '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
          '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
          '    <i class="fas fa-calendar-day"></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
          '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
          '  </div>' +
        '</div>'
      },
      field: 'start',
      filter:'agDateColumnFilter',
      filterParams: {
        comparator:function (filterLocalDateAtMidnight, cellValue) {
          var dateAsString = cellValue.split("T");
          if (dateAsString == null) return -1;
          var dateParts  = dateAsString[0].split("-");
          var cellDate = new Date(Number(dateParts[0]), Number(dateParts[1]) - 1, Number(dateParts[2]));

          if (filterLocalDateAtMidnight.getTime() == cellDate.getTime()) {
            return 0
          }

          if (cellDate < filterLocalDateAtMidnight) {
            return -1;
          }

          if (cellDate > filterLocalDateAtMidnight) {
            return 1;
          }
        },
        browserDatePicker: true,
        suppressAndOrCondition: true,
        buttons: ['clear'],
      },
      cellRenderer: (field) => {
        return this.formatDate(field.value);
      },
      flex: 1,
    },
    {
      sortable: true,
      filter: true,
      filterParams: {
        filterOptions: ['contains'],
        suppressAndOrCondition: true,
        buttons: ['clear'],
        textCustomComparator: function (filter, value, filterText) {
          return value.toLowerCase().includes(filterText.toLowerCase());
        },
      },
      headerName: 'Certificate',
      headerComponentParams: {
        template:
          '<div class="ag-cell-label-container" role="presentation">' +
          '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
          '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
          '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
          '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
          '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
          '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
          '    <i class="fas fa-file-certificate"></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
          '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
          '  </div>' +
          '</div>',
      },
      field: 'attendance_id',
      cellRenderer: 'btnCellRenderer',
      cellRendererParams: {
        clicked: field => {
          if (field.network_member) {
            this.openReviewModal(field.attendance_id);
          } else {
            this.$swal.fire({
              icon: 'info',
              title: this.$t('you-need-to-be-a-member-of-this-network-to-request-a-certificate'),
            });
          }
        },
      },
      valueGetter: function (params) {
        if (params.data.requested) {
          if (params.data.approved === true) {
            return this.$t('network.download');
          } else if (params.data.approved === false) {
            return this.$t('ModerationTab.rejected');
          } else {
            return this.$t('requested');
          }
        } else {
          return this.$t('request');
        }
      },
      flex: 1,
    }
    ];
  },
  mounted() {
    // try checking if this was updated by updating user
    this.$http.get('/auth/me').then(resp => {
      this.user = resp.data;
      this.$store.dispatch('resetUserInfo', resp.data);
    });
    // Handle hash change event on component mount
    this.handleHashChange();
    // Add event listener for hash change
    window.addEventListener('hashchange', this.handleHashChange);
    this.attendanceLog();
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  beforeDestroy() {
    // Remove event listener on component destroy
    window.removeEventListener('hashchange', this.handleHashChange);
  },
  methods: {
    utcToLocal: function (dt) {
      return moment.utc(dt).local();
    },
    formatDate(date) {
      date = new Date(date);
      return ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + '-' + date.getFullYear();
    },
    setActiveTab(tab) {
      this.currentTab = tab;
      this.$router.push({ path: this.$route.path, query: { tab } });
    },
    onSelectionChanged() {
      this.selectedRows = this.gridApi.getSelectedRows();
    },
    sortedArray(array) {
      return orderBy(array, 'start', 'desc');
    },
    contactNow() {
      if (window.umami && typeof window.umami.track === 'function') {
        window.umami.track('open-support-modal');
      }
      this.$bus.emit('show-support-form');
    },
    attendanceLog() {
      this.$http.get('/networks/certificates').then(resp => {
        this.attendance_certificates = Array.isArray(resp.data) ? resp.data : [];
        this.updateUniqueNetworks();
      })
      .then(() => {
        this.loaded = true;
      })
      .catch(error => {
        console.error('Error fetching data', error);
      });
    },
    updateUniqueNetworks() {
      this.uniqueNetworks = [...new Set(this.attendance_certificates.map(item => item.network))];
    },
    toggleButton(button) {
      button.selected = !button.selected;
    },
    submitUserForm(formData) {
      this.submitStatus = 'PENDING';
      formData.network_invite_token = this.urlToken;
      if (formData.country) {
        if (typeof formData.country === 'object' && formData.country.name) {
          if (formData.country.name === 'UNITED STATES' && typeof formData.city != 'object') {
            formData.city = null;
          }
          const exceptions = ['and', 'of', 'the'];
          formData.country = formData.country.name.toLowerCase()
            .split(' ')
            .map((word, index) => {
              if (index === 0 || !exceptions.includes(word)) {
                return word.charAt(0).toUpperCase() + word.slice(1);
              }
              return word;
            })
            .join(' ');
        }
      }
      if (formData.city && typeof formData.city === 'object') {
        formData.city = formData.city.name;
      }
      this.axios
        .post('/auth/update-user', formData)
        .then(resp => {
          this.submitStatus = 'SUCCESS';
          this.$store.dispatch('resetUserInfo', resp.data);
          //this.$store.dispatch('fetchUserWorkInfo');
          this.$bus.emit('profile-progress-submit');

          let msg = this.$t('networks.form.changesSaved');
          let title = this.$t('networks.form.profileUpdated');

          this.$swal.fire({
            icon: 'success',
            title: title,
            text: msg,
          });
        })
        .catch(error => {
          this.submitStatus = 'ERROR';
          if (error.response) {
            // Request made and server responded
            var data = error.response.data;
            if (data.error) {
              this.errors = data.error;
            }
          } else if (error.request) {
            this.errors = this.$t('network.requestRecieved');
            console.log(error.request);
          } else {
            this.errors = this.$t('network.requestError');
            console.log('Error', error.message);
          }
        });
    },
    handleHashChange() {
      const hash = window.location.hash;
      if (hash) {
        // Remove the leading '#' character from the hash
        const tabId = hash.substr(1);

        // Deactivate the current active tab and tab pane (general by default)
        const currentActiveTabElement = document.querySelector('[data-bs-target="#general"]');
        currentActiveTabElement.classList.remove('active');
        const currentActiveContentElement = document.getElementById('general');
        currentActiveContentElement.classList.remove('show', 'active');

        // Activate the corresponding tab
        const tabElement = document.querySelector(`[data-bs-target="#${tabId}"]`);
        tabElement.classList.add('active');
        const tabContentElement = document.getElementById(`${tabId}`);
        tabContentElement.classList.add('show', 'active');
      }
    },
    openReviewModal(element) {
      this.showReviewModal = true;
      this.selectedAttendanceID = element;
    },
    requestCertificate() {
      this.busy = true;
      const textarea = document.getElementById('meeting_review');
      const textareaContent = textarea ? textarea.value : '';
      const requestData = {
        attendance_id: this.selectedAttendanceID,
        selectedOptions: this.buttons.filter(button => button.selected).map(button => button.label),
        review: textareaContent,
      };

      this.$http.post('/networks/certificates/request', requestData).then(() => {
        // reset values on successful submission
        this.showReviewModal = false;
        this.busy = false;
        this.selectedAttendanceID = null;
        this.buttons.forEach(button => button.selected = false);
        if (textarea) {
          textarea.value = '';
          this.review = '';
        }
        this.$swal.fire({
          icon: 'success',
          title: this.$t('the-certificate-request-has-been-successfully-submitted-we-normally-respond-within-2-business-days'),
        }).then(() => {
          this.attendanceLog();
        });
      })
      .catch(error => {
        console.error('API call failed:', error);
        this.$swal.fire({
          icon: 'error',
          title: this.$t('there-was-an-error-submitting-the-request'),
        });
      });
    },
  },
};
</script>
<style>
.nav-profile .nav-item .active {
  background-color: #f7f7fc !important;
  border:0px !important;
  border-radius:0px;
  cursor: none;
  font-weight: bold;
}
.btn-review {
  border-radius: 32px;
  background: #D9D9D9;
  padding: 0.5rem 3rem !important;
  margin-right: 10px;
  margin-bottom: 10px;
}
.btn-selected,
.btn-selected:hover {
  background: #005f9a;
  color: #fff;
}
.ag-header-cell-label {
  justify-content: center;
  font-size: 19px;
  font-weight: 600;
  color: #5c6d80;
}
.ag-theme-alpine .ag-row {
  font-size: 15px;
}
</style>